module.exports = __webpack_public_path__ + "img/003.58735e92.png";